// OpenSeadragon SVG Overlay plugin 0.0.5
// Copied from https://github.com/openseadragon/svg-overlay

// Modified to suit the needs of our WBWUN project

/*
Copyright (C) 2016 svg-overlay contributors

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

- Redistributions of source code must retain the above copyright notice,
  this list of conditions and the following disclaimer.

- Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

- Neither the name of the copyright holder nor the names of its contributors
  may be used to endorse or promote products derived from this software
  without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
POSSIBILITY OF SUCH DAMAGE.

*/

const svgMinFontSize = 30;

(function() {

    var $ = window.OpenSeadragon;

    if (!$) {
        $ = require('openseadragon');
        if (!$) {
            throw new Error('OpenSeadragon is missing.');
        }
    }

    var svgNS = 'http://www.w3.org/2000/svg';

    // ----------
    $.Viewer.prototype.svgOverlay = function() {
        if (this._svgOverlayInfo) {
            return this._svgOverlayInfo;
        }

        this._svgOverlayInfo = new Overlay(this);
        return this._svgOverlayInfo;
    };

    // ----------
    var Overlay = function(viewer) {
        var self = this;

        this._viewer = viewer;
        this._containerWidth = 0;
        this._containerHeight = 0;

        this._svg = document.createElementNS(svgNS, 'svg');
        this._svg.style.position = 'absolute';
        this._svg.style.left = 0;
        this._svg.style.top = 0;
        this._svg.style.width = '100%';
        this._svg.style.height = '100%';
        if(this._viewer.canvas) {
            this._viewer.canvas.appendChild(this._svg);
        } else {
            console.error("Encountered viewer without canvas!");
        }

        // add a filter for tooltip text
        const filterDef = document.createElementNS(svgNS, 'defs');
        const filterRoot = document.createElementNS(svgNS, 'filter');
        filterRoot.setAttribute('x', 0);
        filterRoot.setAttribute('y', 0);
        filterRoot.setAttribute('width', 1);
        filterRoot.setAttribute('height', 1);
        filterRoot.setAttribute('id', 'tooltipfilter');
        const feFlood = document.createElementNS(svgNS, 'feFlood');
        feFlood.setAttribute('flood-color', 'white');
        const feComposite = document.createElementNS(svgNS, 'feComposite');
        feComposite.setAttribute('in','SourceGraphic');
        filterRoot.appendChild(feFlood);
        filterRoot.appendChild(feComposite);
        filterDef.appendChild(filterRoot);
        this._svg.appendChild(filterDef);

        this._node = document.createElementNS(svgNS, 'g');
        this._node.setAttribute("class", "tool-tip-overlay");
        this._svg.appendChild(this._node);

        this._viewer.addHandler('animation', function() {
            self.resize();
        });

        this._viewer.addHandler('open', function() {
            self.resize();
        });

        this._viewer.addHandler('rotate', function() {
            self.resize();
        });

        this._viewer.addHandler('resize', function() {
            self.resize();
        });

        if(this._viewer.container) {
            this.resize();
        }
    };

    // ----------
    Overlay.prototype = {
        destroy: function() {
            this._viewer.canvas.removeChild(this._svg);
            delete this._viewer._svgOverlayInfo;
        },

        // ----------
        node: function() {
            return this._node;
        },

        // ----------
        resize: function() {
            if (this._containerWidth !== this._viewer.container.clientWidth) {
                this._containerWidth = this._viewer.container.clientWidth;
                this._svg.setAttribute('width', this._containerWidth);
            }

            if (this._containerHeight !== this._viewer.container.clientHeight) {
                this._containerHeight = this._viewer.container.clientHeight;
                this._svg.setAttribute('height', this._containerHeight);
            }

            var p = this._viewer.viewport.pixelFromPoint(new $.Point(0, 0), true);
            var zoom = this._viewer.viewport.getZoom(true);
            var rotation = this._viewer.viewport.getRotation();
            // TODO: Expose an accessor for _containerInnerSize in the OSD API so we don't have to use the private variable.
            var referenceElement = this._viewer.canvas.getElementsByClassName("transcript")[0];
            var scale;
            if(referenceElement.firstElementChild.hasAttribute("transform")){
                const transformAttribute = referenceElement.firstElementChild.getAttributeNode("transform");
                scale = /scale\(([0-9.]+)\)/.exec(transformAttribute.value)[1];
                this._node.setAttributeNode(transformAttribute.cloneNode(true));
            } else {
                scale = this._viewer.viewport._containerInnerSize.x * zoom;
                this._node.setAttribute('transform',
                'translate(' + p.x + ',' + p.y + ') scale(' + scale + ') rotate(' + rotation + ')');
            }

            // adjust font-size of tooltip overlay text
            const textElements = this._viewer.canvas.getElementsByClassName("tooltip");
            for(let i = 0; i < textElements.length; i++) {
                const targetSize = 25 / scale < svgMinFontSize ? svgMinFontSize : 25 / scale;
                textElements[i].setAttribute("style", "font-size: " + targetSize + "px;");
            }
        },

        // ----------
        onClick: function(node, handler) {
            // TODO: Fast click for mobile browsers

            new $.MouseTracker({
                element: node,
                clickHandler: handler
            }).setTracking(true);
        }
    };

})();